<template>
	<div class="orderTable">
		<table class="labels-table" style="table-layout:fixed;">
			<thead>
				<tr>
					<th><input type="checkbox" class="labels-table__checkbox" /></th>
					<th>
						<abbr title="Internal ID">
							{{ this.orderData.serial }}
						</abbr>
					</th>
					<th>
						<abbr title="External ID">
							{{ this.orderData.provider }} / {{ this.orderData.external_ref }}
						</abbr>
					</th>
					<th>
						<abbr title="Sale Date">
							{{ this.orderData.sale_datetime }}
						</abbr>
					</th>
					<th>
						<abbr title="Customer Name">
							{{ this.orderData.customer_name }}
						</abbr>
					</th>
					<th>
						<abbr title="Address Line 1">
							{{ this.orderData.shipping_address_1 }}
						</abbr>
					</th>
					<th>
						<abbr title="Address Line 3 - County">
							{{ this.orderData.shipping_address_3 }}
						</abbr>
					</th>
					<th>
						<abbr title="Address Line 4 - City">
							{{ this.orderData.shipping_address_4 }}
						</abbr>
					</th>
					<th>
						<abbr title="Country Code">
							{{ this.orderData.shipping_country_code }}
						</abbr>
					</th>
					<th>
						<div class="menu-btn-box">
							<!-- <span class="menu-btn-box__text">Details</span> -->
							<MobMenuBtn v-on:btnPressed="toggleDetails($event)" alt="DETAIL" title="DETAIL"></MobMenuBtn>
						</div>
					</th>
					<!--
					<th>
						<div class="pdf-dw-btn">
							<a href="#" v-on:click="openDownload()" class="pdf-dw-btn__link" alt="DOWNLOAD" title="DOWNLOAD"></a>
						</div>
					</th>
					-->
				</tr>
			</thead>
		</table>
		<!-- v-if="!areDetailsShown"
				:areDetailsShown="!areDetailsShown" -->
		
		<ItemsTable
			
			
			v-for="(eachitem, index) in itemtableData"
					:key="eachitem.itemserial"
					:itemData="eachitem"
					:idx="index"
					
		></ItemsTable>
		<!--  -->
		<OrderDetails
			v-if="areDetailsShown"
			:areDetailsShown="areDetailsShown"
			:itemtableData="itemtableData"
			:orderData="orderData"
		></OrderDetails>
	</div>
</template>

<script>
import Vue from "vue";
import MobMenuBtn from "@/components/listOrders/MobMenuBtn.vue";
import OrderDetails from "@/components/listOrders/OrderDetails.vue";
import ItemsTable from "@/components/listOrders/ItemsTable.vue";
import { mapActions } from "vuex";
import axios from "axios";

export default Vue.extend({
	name: "OrderTable",
	components: {
		MobMenuBtn,
		OrderDetails,
		ItemsTable
	},
	methods: {
		toggleDetails(isOpen) {
			this.areDetailsShown = isOpen;
		},
		openDownload: function(e) {
		
			let req = {"order_serial":  this.orderData.serial };
			//alert(req);
			
			axios.post("https://new.colorwayrb.com/backend/download_byorder.php?sessionid=" + localStorage.getItem("sessionid"), req)
					.then(({ data }) => {
						
						//alert(data);
						location.href = 'https://new.colorwayrb.com/backend/' + data.returnurl;
						
						
						
					})
					.catch(err => {
						alert("PROBLEM!" + err);
					});
		},
		...mapActions(["getItemData"])
	},
	computed: {
		itemtableData: {
			get() {
				return this.orderData.items;
				//return this.$store.getters.getItemData[this.orderData.serial];
				//return this.$store.getters.getItemDataNew[this.index];
			}
		}
	},
	data() {
		return {
			areDetailsShown: false
		};
	},
	mounted() {
		//this.getItemData(this.orderData.serial);
	},
	props: ["orderData", "index"]
});
</script>

<style lang="scss" scoped>
.orderTable {
	margin-bottom: 15px;
	&:last-child {
		margin-bottom: 0;
	}
	
}
.labels-table {
	&__checkbox {
		transform: translate(-50%, -50%);
		position: absolute;

		height: 17px;
		width: 17px;

		left: 55%;
		top: 50%;
	}

	th {
		border: 1px solid $border-color;
		background-color: lighten($color7, 10%);
		height: 30px;

		text-transform: uppercase;
		text-align: center;
		font-weight: 600;
		font-size: 10px;
		overflow: hidden;
		word-break: break-all;
		
	}
	th:nth-child(1) {
		position: relative;
		width: 30px;
		min-width: 30px;
	}
	th:nth-child(2) {
		width: 100px;
		min-width: 100px;
		
	}
	th:nth-child(3) {
		width: 91px;
		min-width: 91px;
	}
	th:nth-child(4) {
		width: 130px;
	}
	th:nth-child(5) {
		width: 215px;
	}
	th:nth-child(6) {
		width: 286px;
	}
	th:nth-child(7) {
		width: 185px;
	}
	th:nth-child(8) {
		width: 122px;
	}
	th:nth-child(9) {
		width: 70px;
	}
	th:nth-child(10) {
		width: 59px;
	}
	th:nth-child(11) {
		border-left: 1px solid $border-color;
		width: 59px;
	}
}

.menu-btn-box {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 5px;

	&__text {
		margin-left: 7px;
		margin-right: 4px;
	}
}

.pdf-dw-btn {
	display: flex;
	justify-content: center;
	align-items: center;

	&__link {
		background-image: url("../../assets/download.svg");
		background-repeat: no-repeat;
		background-position: center;
		display: inline-block;
		border: 1px solid $border-color;
		border-radius: 5px;
		height: 21px;
		width: 21px;

		background-color: $table-light-bg;
		background-size: 14px;
	}
}
</style>